<template>
    <div v-if="loading" class="ds-settings-loading"><loader /></div>
    <div v-else-if="error" class="ds-settings-state ds-settings-state-error" role="alert">
        <span>Не удалось загрузить роли.</span>
        <btn @click="loadRoles">Повторить</btn>
    </div>
    <div v-else-if="!roles.length" class="ds-settings-state">
        Список ролей пуст.
    </div>
    <div v-else>
        <VTabs :tabs :initial-tab>
            <template v-for="role in roles" v-slot:[role.id]>
                <RoleItem :role />
            </template>
        </VTabs>
    </div>
</template>

<script setup lang="ts">

import { useSettingsStore } from '@/stores/settingsStore';
import { computed, onMounted, ref } from 'vue';
import VTabs from '../VTabs.vue';
import { Tab } from '@/types';
import RoleItem from './RoleItem.vue';
import Loader from '@/ui/Loader.vue';

const settingsStore = useSettingsStore()

const loading = ref(false)
const error = ref(false)
const roles = computed(() => settingsStore.roles)
const tabs = ref<Tab[]>([])
const initialTab = ref('')

const getTabs = () => {
    tabs.value = roles.value.map((item) => {
        return {
            name: item.id,
            label: item.name
        }
    })
}

const loadRoles = async () => {
    loading.value = true
    error.value = Boolean(await settingsStore.fetchRoles())
    if (!error.value) {
        getTabs()
        if(roles.value.length) initialTab.value = '' + roles.value[0]?.id
    }
    loading.value = false
}

onMounted(() => {
    loadRoles()
})

</script>
